module.exports = __webpack_public_path__ + "files/532142b052832f94ffc35860545a7e5c.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/favicon-16x16.png
// module id = 728
// module chunks = 59